var React = require('react');

function TowelGreen (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"#blue_towel .cls-1{fill:#234244;} #blue_towel .cls-2{fill:#fff;}")),React.createElement("title",{"key":1},"jsconf"),React.createElement("g",{"id":"blue_towel","key":2},[React.createElement("rect",{"className":"cls-1","width":"196.9","height":"450.04","key":0}),React.createElement("rect",{"className":"cls-2","y":"47.57","width":"196.9","height":"6","key":1}),React.createElement("rect",{"className":"cls-2","y":"64.25","width":"196.9","height":"6","key":2}),React.createElement("rect",{"className":"cls-2","y":"378.34","width":"196.9","height":"6","key":3}),React.createElement("rect",{"className":"cls-2","y":"396.55","width":"196.9","height":"6","key":4})])]);
}

TowelGreen.defaultProps = {"viewBox":"0 0 196.9 450.04"};

module.exports = TowelGreen;

TowelGreen.default = TowelGreen;
